module.exports = __webpack_public_path__ + "img/144_2.0e1443dc.png";